module.exports = __webpack_public_path__ + "static/logo-ccc0ab8fc65d83b96b35e3e42787d1ad.ico";